var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-box"},[_c('QueryForm',{attrs:{"queryForm":_vm.queryForm,"typeN":2},on:{"QuerySearch":_vm.QuerySearch}}),_c('div',{staticClass:"map_right",attrs:{"id":"container"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }